'use client';

import { contentImageAlt } from '@communio/content-image-alt';
import { YouTubeEmbed } from '@/platform/youtube/YouTubeEmbed';
import './forum-actions.css';

type Props = {
  imageUrls?: string[];
  youtubeVideoId?: string;
  title?: string;
};

export function ForumPostMedia({ imageUrls, youtubeVideoId, title }: Props) {
  const images = (imageUrls ?? []).filter(Boolean);
  if (images.length === 0 && !youtubeVideoId) return null;
  return (
    <div className="forum-post-media">
      {images.length > 0 ? (
        <div className="forum-post-media__grid">
          {images.map((src) => (
            <img
              key={src}
              className="forum-post-media__img"
              src={src}
              alt={contentImageAlt(title, 'post photo')}
              loading="lazy"
            />
          ))}
        </div>
      ) : null}
      {youtubeVideoId ? <YouTubeEmbed videoId={youtubeVideoId} title={title || 'YouTube video'} /> : null}
    </div>
  );
}
